import React, { useEffect, useState } from "react";
import { ErrorMessage, Field } from "formik";
import _ from "lodash";
import GeneralStrings from "../../../strings/GeneralStrings.json";
import { validateRequired } from "../../../utilities/ValidationHelper";
import PackagingConst from "../../../consts/PackagingConst";

const PackagingStep = ({ numberOfSwimmers }) => {
  const [packageOptions, setPackageOptions] = useState([]);
  const PACKAGING_STEP_STRINGS =
    GeneralStrings.ENROLL.FORM_LABELS.PACKAGING_STEP;

  const getPackageOptions = (numberOfSwimmers) => {
    switch (numberOfSwimmers) {
      case "1":
        return "ONE_SWIMMER_OPTION";
      case "2":
        return "TWO_SWIMMER_OPTION";
      case "3":
        return "THREE_SWIMMER_OPTION";
      case "4":
        return "FOUR_SWIMMER_OPTION";
      case "5":
        return "FIVE_SWIMMER_OPTION";
      default:
        return "";
    }
  };

  useEffect(() => {
    const packageOption = getPackageOptions(numberOfSwimmers);
    setPackageOptions(PackagingConst[packageOption]);
  }, [numberOfSwimmers]);

  return (
    <div className="step">
      <h4
        className="step-header"
        dangerouslySetInnerHTML={{
          __html: PACKAGING_STEP_STRINGS.HEADER_HTML,
        }}
      />
      <div className="question-container">
        <div className="form-group">
          <Field
            as="select"
            name="swimmingPackage"
            className="form-control"
            validate={validateRequired}
          >
            <option value=""></option>
            {packageOptions?.map((option) => (
              <option value={option} key={option}>
                {option}
              </option>
            ))}
          </Field>
          <ErrorMessage
            component="span"
            className="form-error"
            name="swimmingPackage"
          />
        </div>
      </div>
    </div>
  );
};

export default PackagingStep;
